import React from "react";
import { Box, Image, Input } from "theme-ui";

import { MinusButton, PlusButton } from "components/Buttons";
import { RootState } from "store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  addCart,
  getCartItemById,
  removeCart,
} from "store/productPayment/cart";
import { getGoodsById } from "store/productPayment/goods";

interface ProductItemProps {
  id: string;
}

function ProductItem({ id }: ProductItemProps) {
  const dispatch = useAppDispatch();

  const product = useAppSelector((state: RootState) =>
    getGoodsById(state, { id })
  );
  const productCart = useAppSelector((state: RootState) =>
    getCartItemById(state, { id })
  );

  function handleMinusClick() {
    dispatch(removeCart({ productTID: id }));
  }
  function handlePlusClick() {
    if (product) {
      dispatch(addCart(product));
    }
  }

  if (!product) {
    return null;
  }

  return (
    <Box
      sx={{
        borderBottom: "1px solid",
        borderBottomColor: "#ededed",
        height: "130px",
        padding: "20px 8px",
      }}
    >
      <Box
        sx={{
          paddingLeft: "100px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            border: "1px solid",
            borderColor: "#ededed",
            height: "84px",
            position: "absolute",
            left: 0,
            top: 0,
            width: "89px",
          }}
          onClick={handlePlusClick}
        >
          <Image
            height="100%"
            src={product.productMainThum as string}
            width="100%"
            sx={{
              maxHeight: "80px",
            }}
          />
        </Box>
        <Box sx={{ paddingTop: "5px" }}>
          <Box
            sx={{
              color: "#000",
              fontSize: "14px",
              fontWeight: 400,
              marginBottom: "3px",
            }}
            onClick={handlePlusClick}
          >
            {product.productKorName}
          </Box>
          <Box
            sx={{
              color: "#000",
              fontSize: "16px",
              fontWeight: 500,
              marginBottom: "10px",
            }}
            onClick={handlePlusClick}
          >
            {Number(product.saleAmt).toLocaleString()}원
          </Box>
          <Box
            sx={{
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                float: "left",
                height: "30px",
                position: "relative",
                textAlign: "center",
                width: "85px",
              }}
            >
              <MinusButton onClick={handleMinusClick} />
              <Input
                type="number"
                value={productCart?.saleQty ?? 0}
                sx={{
                  borderRadius: "3px",
                  border: "1px solid",
                  borderColor: "#bbbbbb",
                  color: "#000",
                  display: "inline-block",
                  fontSize: "14px",
                  fontWeight: 500,
                  height: "30px",
                  lineHeight: "1.15",
                  padding: 0,
                  textAlign: "center",
                  width: "30px",
                }}
                onChange={() => {}}
              />
              <PlusButton onClick={handlePlusClick} />
            </Box>
            <Box
              sx={{
                cursor: "pointer",
                float: "left",
                textAlign: "right",
                fontSize: "12px",
                color: "#666666",
                height: "30px",
                alignItems: "center",
                display: "flex",
                width: "calc(100% - 85px)",
              }}
              onClick={handlePlusClick}
            >
              <Box sx={{ textAlign: "right", width: "100%" }}>
                현재고{" "}
                <Box
                  as="span"
                  sx={{
                    color: "#000",
                    fontWeight: "bold",
                  }}
                >
                  {Number(product.qty).toLocaleString()}
                </Box>
                개
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ProductItem;
